import React from 'react';
import { Spinner } from './Spinner';

/**
 * Standard loading state — centred spinner with an optional message.
 * `fullPage` renders inside the standard app page shell so every
 * screen's loading view looks identical.
 */
export function LoadingState({ message = 'Loading…', fullPage = false, className = '', ...props }) {
  const body = (
    <div className="text-center">
      <Spinner size="lg" className="mx-auto mb-4" />
      {message && <p className="text-gray-600 dark:text-gray-400">{message}</p>}
    </div>
  );

  if (fullPage) {
    return (
      <div
        className={`min-h-screen bg-gradient-to-br from-gray-50 via-brand-50 to-brand-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex items-center justify-center ${className}`}
        role="status"
        {...props}
      >
        {body}
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center py-12 ${className}`} role="status" {...props}>
      {body}
    </div>
  );
}

export default LoadingState;
